export default "__VITE_ASSET__e30f7c8d__"